import React, { useEffect, useState } from "react";
import Dashboardsidebar from "../../layouts/Dashboardsidebar";
import * as CONSTANTS from "../dashboard/constants/DashboardConstants";
import { useNavigate, Link } from "react-router-dom";
import { RoutesPath } from "../../constants";
import { injectModels } from "../../redux/injectModels";
import PropTypes from "prop-types";
import Footer from "../../layouts/Footer";

const Dashboard = ({ auth, loader }) => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [summary, setSummary] = useState({ draft: 0, in_progress: 0, completed: 0 });
    const [recentDocs, setRecentDocs] = useState([]);

    // Load user name and dashboard data
    useEffect(() => {
        const name = localStorage.getItem("userName");
        setUserName(name || "");
        fetchDashboardData();
    }, []);

    /** ================
     * Fetch Dashboard Data
     * ================ */
    const fetchDashboardData = async () => {
        try {
            loader.setLoading(true);
            const res = await auth.getdashboardDetails();
            loader.setLoading(false);

            // Handle both raw and wrapped API responses
            const data = res.data ? res.data : res;

            console.log(" Dashboard API response:", data);

            if (data?.summary) {
                setSummary(data.summary);
                setRecentDocs(data.recent_documents || []);
            } else {
                setSummary({ draft: 0, in_progress: 0, completed: 0 });
                setRecentDocs([]);
            }
        } catch (err) {
            console.error(" Error fetching dashboard:", err);
            loader.setLoading(false);
            setSummary({ draft: 0, in_progress: 0, completed: 0 });
            setRecentDocs([]);
        }
    };

    const handleRedirect = (statusKey) => {
        navigate(RoutesPath.MANAGEPAGE, { state: { activeTab: statusKey } });
    };

    const handleSendDocument = () => {
        navigate(RoutesPath.SENDPAGE);
    };


    const statusColors = {
        draft: "#31B7BC",
        in_progress: "#F39200",
        completed: "#94B654",
    };

    const getStatusKey = (status) =>
        status?.toLowerCase().replace(/\s+/g, "_");

    // const statusPercentages = {
    //     Draft: 50,
    //     In_progress: 25,
    //     Completed: 100,
    // };



    return (
        <Dashboardsidebar>
            <div className="dashboard-wrapper">
                <div className="row card-section-dashboard">
                    {/* Welcome Card */}
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="welcome-card">
                                <div className="welcome-text">
                                    <h5 className="welcome-title">Welcome back, {userName || "User"}!</h5>

                                    <p className="welcome-sub">
                                        {CONSTANTS.CARD_TEXT.map((text, i) => (
                                            <React.Fragment key={i}>
                                                {text}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </p>
                                </div>

                                <img
                                    src="/assets/img/Group237226.png"
                                    className="welcome-img"
                                    alt="dashboard visual"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Status Summary */}
                    <div className="col-sm-6">
                        <div className="rightside-col">
                            {/* Draft */}
                            <div className="status-box draft" onClick={() => handleRedirect("draft")}>
                                <div className="status-row">
                                    <span className="status-value">{summary.draft || 0}</span>
                                    <div className="status-icon draft-icon"></div>
                                </div>
                                <p className="status-label">Draft</p>
                            </div>

                            {/* In Progress */}
                            <div className="status-box inprogress" onClick={() => handleRedirect("in_progress")}>
                                <div className="status-row">
                                    <span className="status-value">{summary.in_progress || 0}</span>
                                    <div className="status-icon inprogress-icon"></div>
                                </div>
                                <p className="status-label">In Progress</p>
                            </div>

                            <div className="status-box completed" onClick={() => handleRedirect("completed")}>
                                <div className="status-row">
                                    <span className="status-value">{summary.completed || 0}</span>
                                    <div className="status-icon completed-icon"></div>
                                </div>
                                <p className="status-label">Completed</p>
                            </div>
                        </div>
                        <br />
                    </div>

                    {/* Sign or Get Signatures */}
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <div className="outer-box">
                                <div className="signature-action" onClick={handleSendDocument}>
                                    <img
                                        src="/assets/img/tap-icon.png"
                                        alt="tap icon"
                                        className="tap-icon"
                                    />
                                    <span>Sign or get signatures</span>
                                </div>
                            </div>
                        </div>

                        {/* Recent Documents */}
                        <div className="col-md-6">

                            <div className="recent-documents">
                                <div className="recent-header d-flex justify-content-between align-items-center">
                                    <h5 className="m-0 recent-documents-text">Recent Documents</h5>
                                    <Link to="/manage" className="view-link">{CONSTANTS.VIEW}</Link>
                                </div>

                                <div className="document-list">
                                    {recentDocs.length === 0 ? (
                                        <p className="no-documents text-muted">No recent documents available.</p>
                                    ) : (
                                        recentDocs.map((doc, index) => {
                                            const statusKey = getStatusKey(doc.status);
                                            return (
                                                <div className="document-card" key={index}>
                                                    <div className="doc-info">
                                                        <div className="doc-title">{doc.agreement_name}</div>

                                                        <div className="doc-meta">
                                                            👥 {doc.recipient_count} recipient{doc.recipient_count > 1 ? "s" : ""}
                                                            &nbsp;•&nbsp;
                                                            ⏰ {doc.updated_at || "N/A"}
                                                        </div>
                                                    </div>

                                                    <div className="progress-container">

                                                        <div
                                                            className="status-chip"
                                                            style={{
                                                                backgroundColor: `${statusColors[statusKey] || "#ccc"}20`,
                                                                color: statusColors[statusKey] || "#333",
                                                            }}
                                                        >
                                                            {doc.status}
                                                        </div>

                                                        {/* <div
                                                        className="progress-circle"
                                                        style={{
                                                            borderColor: statusColors[doc.status.toLowerCase()] || "#999",
                                                        }}
                                                    >
                                                        <span className="percent-value">
                                                            {statusPercentages[doc.status] || 0}%
                                                        </span>
                                                    </div> */}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer variant="dashboard" />
        </Dashboardsidebar>
    );
};

Dashboard.propTypes = {
    auth: PropTypes.shape({
        getdashboardDetails: PropTypes.func.isRequired,
    }).isRequired,
    loader: PropTypes.shape({
        setLoading: PropTypes.func.isRequired,
    }).isRequired,
};

export default injectModels(["auth", "loader"])(Dashboard);